
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-we-handle-data",
      function () {
        return require("private-next-pages/how-we-handle-data.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-we-handle-data"])
      });
    }
  